<p-selectButton [options]="days" [(ngModel)]="value" multiple="multiple" optionLabel="value" optionValue="value" styleClass="c-weekly-list"></p-selectButton>

